import { mapState, mapGetters, mapActions } from 'vuex'

export const agentDetailsComputed = {
  ...mapState('agentDetails', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('agentDetails', [
    'getDetails',
    'getErrors',
    'getEditErrors',
    'getEditStatus',
  ]),
}

export const agentDetailsMethods = mapActions('agentDetails', [
  'getDetailsById',
  'resetAgentDetails',
  'updateAgent',
  'resetEditAgent',
  'resetAll',
])
